var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluvialFloodSr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.152 18.009a9.184 9.184 0 0 0-3.069-.509c-2.475 0-4.17.316-5.083.948v2.538c1.01-.632 2.725-.948 5.149-.948 1.797 0 3.09.48 4.353.965a7.464 7.464 0 0 1-1.35-2.994Zm-.132-2.06a9.89 9.89 0 0 0-2.871-.413c-2.559 0-4.275.316-5.149.947v-2.536c.742-.513 2-.818 3.774-.914l.001-1.102h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.106-.106L11.14 2l3.04 3.245V3.968c0-.474.506-.71 1.52-.71.944 0 1.463.206 1.555.618l.013.092v4.344l.753.706a7.493 7.493 0 0 0-6.752 3.305h-.744a1 1 0 0 0-.993.883l-.004.104c.363.095.705.206 1.038.324a7.461 7.461 0 0 0-.547 2.315Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 23a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm-3.723-10.25h7.556v1.84h-7.556v-1.84Zm0 2.76h1.89v5.521h-1.89v-5.52Zm2.834 0h1.89v5.521h-1.89v-5.52Zm4.721 0h-1.889v5.521h1.89v-5.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluvialFloodSr);
export default __webpack_public_path__ + "static/media/fluvial_flood_sr.0394b30d3fa9fb27f8f574bd2a908be6.svg";
export { ForwardRef as ReactComponent };